"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  MapServices: () => MapServices
});
module.exports = __toCommonJS(unavailable_exports);
var import_nativeError = require("../nativeError");
var MapServices = Object.freeze({
  search: function search(_query, _center) {
    var _radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
    return Promise.resolve([]);
  },
  autocomplete: function autocomplete(_query, _center) {
    var _radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
    return Promise.resolve([]);
  },
  resolveSuggestion: function resolveSuggestion(_id) {
    return Promise.reject((0, import_nativeError.missingNativeBuild)("MapServices.resolveSuggestion"));
  },
  directions: function directions(_origin, _destination) {
    var _transport = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "driving";
    return Promise.reject((0, import_nativeError.missingNativeBuild)("MapServices.directions"));
  }
});
//# sourceMappingURL=unavailable.js.map
